module.exports = __webpack_public_path__ + "static/media/ic-actions-file.895b3c4c.svg";